// components/modules/Buttons/PayPalButton.jsx

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from 'axios';

const PayPalButton = ({ orderData, onSuccess, onError }) => {
    const totalAmount = orderData?.importo_totale || 0;
    
    // ✅ VERIFICA CHE IL CLIENT ID ESISTA
    const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
    console.log("🔑 PayPal Client ID presente?", clientId ? "✅ SI" : "❌ NO");
    
    if (!clientId) {
        console.error("❌ REACT_APP_PAYPAL_CLIENT_ID mancante nel .env");
        return <div>Errore configurazione PayPal</div>;
    }
    
    const createOrder = async () => {
        try {
            const response = await axios.post("/api/create-paypal-order", {
                amount: totalAmount,
                currency: "EUR",
                orderId: orderData.numero_ordine
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.data.id;
        } catch (error) {
            console.error("Errore createOrder:", error);
            if (onError) onError(error);
        }
    };
    
    const onApprove = async (data) => {
        try {
            const response = await axios.post("/api/capture-paypal-order", {
                orderID: data.orderID,
                orderData: orderData
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (onSuccess) onSuccess(response.data);
        } catch (error) {
            console.error("Errore onApprove:", error);
            if (onError) onError(error);
        }
    };
    
    return (
        <PayPalScriptProvider
            options={{
                "client-id": clientId,
                currency: "EUR",
                intent: "capture",
                locale: "it_IT", 
                components: "buttons",
                "disable-funding": "card"
            }}
        >
            <PayPalButtons
                key={orderData.numero_ordine}
                createOrder={createOrder}
                onApprove={onApprove}
                onError={onError}
                style={{
                    layout: "vertical",
                    color: "gold",
                    shape: "rect",
                    label: "paypal",
                    zIndex: 1
                }}
            />
        </PayPalScriptProvider>
    );
};

export default PayPalButton;